import { MatSpinner, MatProgressSpinner } from '@angular/material/progress-spinner';
import { ChangeDetectionStrategy, Component, inject, signal, ViewChild } from '@angular/core';
import { TitleComponent } from "../../../shared/components/title-component/title-component";
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { AvenantService } from '../../service/avenant-service';
import { ToastrService } from '../../../shared/services/toastr-service';
import { Assurance, Assure, Avenant, Compagnie, Conducteur, Collaborateur, GarantieI, ListItem, ModalListItemI, Site, Stock, Vehicule } from '../../../shared/model';
import { MatListModule } from '@angular/material/list';
import { AsyncPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { AuthService } from '../../../auth/services/auth-service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect, MatOption, MatSelectModule } from "@angular/material/select";
import { SweetAlertService } from '../../../shared/services/sweet-alert-service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { addDays, differenceInDays } from 'date-fns';
import { SearchBarComponent } from "../../../shared/components/search-bar-component/search-bar-component";
import { ListModalComponent } from '../../../shared/components/list-modal-component/list-modal-component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { from, map, Observable, startWith } from 'rxjs';
import { PrintService } from '../../../shared/services/print-service';
import { AssuranceComponentModal } from '../../../assurer/components/modal/modal-assurance';
import { AssuranceService } from '../../../assurer/service/assurance-service';
import { AssureService } from '../../../assurer/service/assure-service';
import { PrintLinkComponentModal } from '../../../assurer/components/modal/modal-print-link';
import { VehiculeService } from '../../../assurer/service/vehicule-service';

interface ModalDataI{
  title : string
  update ?: boolean
  data ?: Avenant,
  assurance ?: Assurance
  compagnie ?:Compagnie
  conducteur ?: Conducteur
  vehicule ?: Vehicule
  assure ?: Assure
  garanties ?: GarantieI[]
  reduction ?:number
}

interface ModalRenouvelleI{
  title : string
  update ?: boolean
  assurance ?: any
  garanties ?: GarantieI[]
}

interface AvenantListI{
  title : string
  key : string
  disable : boolean
}


@Component({
  selector: 'app-avenant-component',
  imports: [
    TitleComponent,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIcon,
    MatSpinner,
    MatListModule,
    DatePipe,
    MatTooltip,
    MatTableModule
],
  templateUrl: './avenant-component.html',
  styleUrl: './avenant-component.css',
})
export class AvenantComponent {

  refControl : FormControl = new FormControl('')

  loading = signal<boolean>(false)

  assurance : Assurance = new Assurance()
  conducteur : Conducteur = new Conducteur()
  assure : Assure = new Assure()
  vehicule : Vehicule = new Vehicule()
  site : Site = new Site()
  collaborateur : Collaborateur = new Collaborateur()
  compagnie : Compagnie = new Compagnie()
  garantie : GarantieI[] = []
  reduction : number = 0

  show = signal<boolean>(false)

  displayedColumns: string[] = ['name', 'editor_name', 'created_at', 'action'];
  dataSource: MatTableDataSource<Avenant> = new MatTableDataSource();

  police : string =""
  readonly dialog = inject(MatDialog);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  key : string = ''

  constructor(
    private avenantService : AvenantService,
    private toastr : ToastrService,
    private authUser : AuthService,
    private sweetAlert : SweetAlertService,
    private printService : PrintService
  ){}

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.refControl.valueChanges.subscribe((val : string) =>{

    })
  }

  onSearchTrigger(){

  }

  openAvenantPrintLink(id : string){
    const dialogRef = this.dialog.open(PrintLinkComponentModal, {
       width: '800px',
      height : '400px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : {id : id}
    });
  }

  openContratPrintLink(id : string){
    const dialogRef = this.dialog.open(PrintLinkComponentModal, {
      width: '800px',
      height : '400px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : {id : id}
    });
  }

  loadAssurance(){
    this.loading.update(val => true)
    const ref = (this.refControl.value).trim()
    //console.log(ref);

    if(ref!=""){
        this.avenantService.checkAssurance(ref).subscribe({
          next : (res) =>{
            console.log(res);
            if(!res?.offline){
              this.police = res.assurance.police
              this.assurance = res.assurance
              this.conducteur = res.conducteur,
              this.assure = res.assure
              this.vehicule = res.vehicule
              this.site = res.site
              this.collaborateur = res.collaborateur
              this.compagnie = res.compagnie
              this.garantie = res.garanties
              this.reduction = res.reduction
              this.dataSource.data = res.assurance.avenants
              this.toastr.success("")
              this.loading.update(val => false)
              this.show.update(val => true)
            }else{
                this.toastr.info("Ce numero de police à été produit hors ligne")
                const data : ModalListItemI = {
                  title : "Liste des vehicules assures hors ligne",
                  data : res?.vehicules.slice().map((item : Vehicule) =>  ({id : item.assurance_id, name : (item.marque+' '+item.model+' : '+item.immatriculation).toUpperCase()}))
                }

                console.log(data);


                const dialogRef = this.dialog.open(ListModalComponent, {
                  width : '700px',
                  enterAnimationDuration : '500ms',
                  exitAnimationDuration : '500ms',
                  disableClose : true,
                  data : data
                });

                dialogRef.afterClosed().subscribe((result : ListItem) => {
                  if (result.id != '') {
                    console.log(result);
                    this.avenantService.loadOfflineAssurance(result.id).subscribe({
                      next : (res) =>{
                          this.police = res.assurance.police
                          this.assurance = res.assurance
                          this.conducteur = res.conducteur,
                          this.assure = res.assure
                          this.vehicule = res.vehicule
                          this.site = res.site
                          this.collaborateur = res.collaborateur
                          this.compagnie = res.compagnie
                          this.garantie = res.garanties
                          this.reduction = res.reduction
                          this.dataSource.data = res.assurance.avenants
                          this.toastr.success("")
                          this.loading.update(val => false)
                          this.show.update(val => true)
                      },
                      error : (err) =>{
                        this.toastr.error(err.error.message)
                        this.loading.update(val => false)
                        this.show.update(val => false)
                      }
                    })
                  }
                });
            }
          },
          error : (err) =>{
            this.toastr.error(err.error.message)
            this.loading.update(val => false)
            this.show.update(val => false)
          }
        })
      }
  }

  applyFilter(event : string){

    this.dataSource.filter = event.trim().toLocaleLowerCase()

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  resetSearch(){
    this.refControl.setValue("")
    this.show.update(val => false)
  }

  openAddAvenantModal(){
    const data : ModalDataI = {
      title : 'Effectuer un Avenant',
      data : new Avenant(),
      assurance : this.assurance,
      conducteur : this.conducteur,
      assure : this.assure,
      garanties : this.garantie,
      vehicule : this.vehicule,
      compagnie : this.compagnie,
      reduction : this.reduction
    }

    const dialogRef = this.dialog.open(AvenantComponentModal, {
      width: '500px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : string) => {
      if (result) {
        this.refControl.setValue(result)
        this.loadAssurance()
        this.sweetAlert.success('', 2000)
        //this.resetSearch()
      }
    });
  }


}

@Component({
  selector: 'app-avenant-modal',
  imports: [
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    UpperCasePipe,
    DatePipe,
    MatIcon,
    MatSpinner
],
  templateUrl: '../modal/modal-avenant.html',
  styleUrl: '../modal/modal-avenant.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvenantComponentModal {
  readonly dialogRef = inject(MatDialogRef<AvenantComponentModal>);

  // recupere les donnees envoyes par le parent
  readonly inputData = inject<ModalDataI>(MAT_DIALOG_DATA);

  avenantForm : FormGroup = new FormGroup({})
  conducteurForm : FormGroup = new FormGroup({})
  assuranceForm :  FormGroup = new FormGroup({})
  currentAvenant : Avenant = new Avenant()
  loadingVehicule = signal<boolean>(false)
  readonly dialog = inject(MatDialog);

  newDateReport = signal<string>('')

  avenantListe : AvenantListI[] = [
    {title : 'Annulation', key : 'annule', disable : false},
    {title : "Changement d'immatriculation", key : 'immat', disable : false},
    {title : 'Duplicata', key : 'duplicata', disable : false},
    /*{title : "Changement de conducteur", key : 'conducteur', disable : false},
    {title : "Changement d'immatriculation", key : 'immat', disable : false},
    {title : "Changement de garantie", key : 'garantie', disable : false},*/
    {title : "Changement de nom", key : 'changeName', disable : false},
    {title : 'Remise en vigueur', key : 'remise', disable : false},
    {title : 'Renouvellement', key : 'renouvelle', disable : false},
    {title : 'Resiliation', key : 'resiliation', disable : false},
    {title : 'Report de date', key : 'report_date', disable : false},
    {title : 'Suspension', key : 'suspendu', disable : false},
    {title : "Transfert de garanties", key : 'vehicule', disable : false}
  ]

  stocks : Stock[] = []
  attestationList : ListItem[] = []
  carteRoseList : ListItem[] = []
  loadVehiculeNa = signal(false)
  stock_attestation : string = ""
  stock_carte_rose : string = ""

  constructor(
    private fb : FormBuilder,
    private avenantService : AvenantService,
    private toastr : ToastrService,
    private sweetService : SweetAlertService,
    private printService : PrintService,
    private assuranceService : AssuranceService,
    private assureService : AssureService,
    private vehiculeService : VehiculeService
  ){

  }

  ngOnInit(): void {
    this.avenantForm = this.fb.group({
      name : ['', [Validators.required]],
      assurance_id : [''],
      date_effet : [''],
      date_fin : [''],
      periode : [''],
      report_date : [0],
      immat : [''],
      vehicule_id : [''],
      vehicule_name : [''],
      assure_id : [this.inputData.assure?.id],
      firstname : [this.inputData.assure?.firstname?this.inputData.assure?.firstname:this.inputData.assure?.representant],
      lastname : [this.inputData.assure?.lastname],
      gender : [this.inputData.assure?.gender]
    })

    this.assuranceForm = this.fb.group({
      attestation : ['', Validators.required],
      carte_rose : ['', Validators.required]
    })

    //on desactive certains avenant en fonction de l'avenant courantss
    this.avenantListe.forEach(item =>{
      if(!this.inputData.assurance?.suspendu && item.key == 'remise')
        item.disable = true


    })

    this.loadDocuments()
  }

  ngAfterViewInit(): void {
    this.avenantForm.patchValue(this.inputData?.data!)

    this.avenantForm.get('name')?.valueChanges.subscribe((value : string) => {
      if(value != '')
        this.onSelectAction(value)
    })



    this.newDateReport.update(val => this.inputData.assurance?.date_fin!)

    this.avenantForm.get('report_date')?.valueChanges.subscribe((value : number) => {
      if(value > 0){
        const date = new Date(this.inputData.assurance?.date_fin!)
        date.setDate(date.getDate() + value)
        this.newDateReport.update(val => date.toDateString())
      }else{
        this.newDateReport.update(val => this.inputData.assurance?.date_fin!)
      }

    })
  }

  checkValue(key : string, value : string, fromName : string){
    if(value == '')
      return;

    this.vehiculeService.checkValues(key, value.toUpperCase().trim().replaceAll(" ", ""))
    .then((res) =>{
      if(res)
        this.avenantForm?.get(fromName)?.setErrors({'exist' : true})
      else
        this.avenantForm?.get(fromName)?.setErrors(null)
    })
  }

  loadDocuments(){
    this.assuranceService.listeDocumenst().subscribe({
      next : (res) =>{
        console.log(res);
        this.stocks.push(...res.stocks.slice())

        const dataStock = []
        console.log(this.stocks);
        dataStock.push(...this.stocks.filter(item => item.type == this.inputData.assurance?.type && item.compagnie_id == this.inputData.assurance.compagnie_id))

        if(dataStock.length == 0){
          this.toastr.war("Aucun documents de type "+this.inputData.assurance?.type+ " pour la compagnie "+this.inputData.compagnie?.name)
          this.toastr.info("Veuillez vous ravitailler")
          this.attestationList.splice(0, this.attestationList.length)
          this.carteRoseList.splice(0, this.carteRoseList.length)
          return;
        }

      const currentCompagnie :any = res.compagnies.filter(item => item.compagnie_id == this.inputData.assurance?.compagnie_id)[0]

      //attestation
      this.assuranceForm.get('attestation')?.setValue('')
      this.attestationList.splice(0, this.attestationList.length)
      dataStock.forEach(item =>{
        const range = (item.attestation_range?.split("-"))?.map(item => parseInt(item))??[]
        const rangeUsed = (item.attestation_used?.split(","))?.map(item => (item))??[]
        for (let index = range[0]; index < (range[1]+1); index++) {
            const att = currentCompagnie.compagnie_code+'*'+this.inputData.assurance?.type+'*'+index.toString().padStart(7, '0')
            if(rangeUsed.indexOf(att) != -1)
              continue;
            this.attestationList.push({id : item.id, name : att})
        }
      })

      //carte rose
      this.assuranceForm.get('carte_rose')?.setValue('')
        this.carteRoseList.splice(0, this.carteRoseList.length)
        dataStock.forEach(item =>{
          const range = (item.carte_rose_range?.split("-"))?.map(item => parseInt(item))??[]
          const rangeUsed = (item.carte_rose_used?.split(","))?.map(item => parseInt(item))??[]
          for (let index = (range[0]); index < (range[1]+1); index++) {
              if(rangeUsed.indexOf(index) != -1)
                continue;
              const cr = index.toString()
              this.carteRoseList.push({id : item.id, name : cr})
          }
        })
      },
      error : (err) =>{

      }
    })
  }

  vehiculesNonVehicules(){
    this.loadVehiculeNa.update(val => true)
    this.assureService.vehiculesNoAssure(this.inputData.assurance?.assure_id!, this.inputData.assurance?.vehicule_id!)
    .subscribe((res) =>{
      this.loadVehiculeNa.update(val => false)

      const list : ListItem[] = res.map(item => {
         const vehicule_name = (item.marque+" "+item.model+ " ( "+item.immatriculation+" / "+item.chassis+" )").toUpperCase()
        return {name : vehicule_name, id : item.id}
      })
      const data : ModalListItemI = {
        title : "Liste vehicules",
        data : list
      }

      const dialogRef = this.dialog.open(ListModalComponent, {
        width : '700px',
        enterAnimationDuration : '500ms',
        exitAnimationDuration : '500ms',
        disableClose : true,
        data : data
      });

      dialogRef.afterClosed().subscribe((result : ListItem) => {
        if (result.id != '') {
          this.avenantForm.get('vehicule_id')?.setValue(result.id)
          this.avenantForm.get('vehicule_name')?.setValue(result.name)
        }
      });
    })
  }

  setEndDateForRemise(){

    let periode = differenceInDays(new Date(this.inputData.assurance?.date_fin!), new Date(this.currentAvenant.created_at))

    if(periode==0 || periode == undefined){
      this.toastr.war('La periode restante est egale a 0 jours')
      return;
    }

    const pe = Math.round(periode + (periode/3))

    const effet = new Date(this.avenantForm.get('date_effet')?.value)

    const fin = addDays(effet, pe)

    this.avenantForm.get('date_effet')?.setValue(effet)
    this.avenantForm.get('date_fin')?.setValue(fin)
    this.avenantForm.get('periode')?.setValue(pe)
  }

  onSelectAction(val : string){
    switch (val) {
      case 'remise':
        this.currentAvenant = (this.inputData.assurance?.avenants.filter(item => item.name=='suspendu'))![0]
        this.avenantForm.get('date_effet')?.setValidators(Validators.required)
        break;

      case 'renouvelle':
        this.openAssuranceModal()
        break;

      case 'report_date':

        break;

      default:
        break;
    }

    this.assuranceForm.get('attestation')?.setValue('')
    this.assuranceForm.get('carte_rose')?.setValue('')
  }

  onAdd(){
    const data = this.avenantForm.value;
    data['assurance_id'] = this.inputData.assurance?.id
    data['compagnie_id'] = this.inputData.compagnie?.id
    data['attestation'] = this.assuranceForm.get("attestation")?.value
    data['carte_rose'] = this.assuranceForm.get("carte_rose")?.value
    data['vehicule_id'] = this.avenantForm.get('vehicule_id')?.value
    data['stock_carte_rose'] = this.stock_carte_rose
    data['stock_attestation'] = this.stock_attestation

    this.sweetService.confirm('Etez-vous sur de vouloir appliquer cet avenant')
    .then((res) =>{
      if(res.isConfirmed){
         this.avenantService.saveAvenant(data).subscribe({
            next : (res) =>{
              this.dialogRef.close(res?.police)
            },
            error : (err) =>{
              this.toastr.error((err.error.message)??"une erreur est survenue")
            }
          })
      }
    })
  }

  openAssuranceModal(){

    const data : ModalRenouvelleI = {
      title : 'Avenant de renouvellement',
      update : true,
      assurance : {
        id : this.inputData.assurance?.id,
        compagnie_id : this.inputData.compagnie?.id,
        compagnie_name : this.inputData.compagnie?.name,
        type : '',
        type_name : '',
        attestation : '',
        carte_rose : '',
        stock : '',
        categorie : this.inputData.assurance?.categorie,
        zone : this.inputData.assurance?.zone,
        date_effet : '',
        periode : 0,
        date_fin : '',
        reduction : this.inputData.reduction,
        vignette : 0,
        licence_transport : false,
        //
        conducteur : this.inputData.conducteur!,
        assure : this.inputData.assure?.id,
        vehicule : this.inputData.vehicule?.id
      },
      garanties : this.inputData.garanties
    }

    const dialogRefM = this.dialog.open(AssuranceComponentModal, {
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRefM.afterClosed().subscribe((result : Assurance) => {
      if (result?.id != "" && result.id != undefined) {
        this.dialogRef.close()
      }
    });
  }

  selectCarteRose(){
    const data : ModalListItemI = {
      title : "N* Carte rose",
      data : this.carteRoseList
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        console.log(result);
        this.assuranceForm.get('carte_rose')?.setValue(result.name)
        this.stock_carte_rose = result.id
      }
    });
  }

  selectAttestation(){
    const data : ModalListItemI = {
      title : "N* Attestation",
      data : this.attestationList
    }

    const dialogRef = this.dialog.open(ListModalComponent, {
      width : '700px',
      enterAnimationDuration : '500ms',
      exitAnimationDuration : '500ms',
      disableClose : true,
      data : data
    });

    dialogRef.afterClosed().subscribe((result : ListItem) => {

      if (result.id != '') {
        console.log(result);
        this.assuranceForm.get('attestation')?.setValue(result.name)
        this.stock_attestation = result.id
      }
    });
  }

}

